// extracted by mini-css-extract-plugin
export default {"pillBar":"pill-bar-module__pillBar___bkKYd"};